<div class="dialog-actions d-flex justify-content-end">
  <ng-content></ng-content>
</div>
